import { render, staticRenderFns } from "./BaseDuration.vue?vue&type=template&id=78f91c0f&scoped=true&"
import script from "./BaseDuration.vue?vue&type=script&lang=ts&"
export * from "./BaseDuration.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDuration.vue?vue&type=style&index=0&id=78f91c0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f91c0f",
  null
  
)

export default component.exports